<ngx-extended-pdf-viewer
  [src]="fileUrl"
  [customToolbar]="additionalButtons"
  height="100%"
  width="100%"
>
  ></ngx-extended-pdf-viewer
>

<ng-template #additionalButtons>
  <div id="toolbarViewer">
    <div id="toolbarViewerLeft">
      <!-- <pdf-toggle-sidebar></pdf-toggle-sidebar>
      <pdf-paging-area></pdf-paging-area> -->
    </div>
    <!-- <pdf-zoom-toolbar></pdf-zoom-toolbar> -->
    <!-- toolbar viewer middle -->
    <div id="toolbarViewerRight">
      <!-- <pdf-presentation-mode></pdf-presentation-mode> -->
      <pdf-print></pdf-print>
      <!-- <app-open-in-new-tab></app-open-in-new-tab> -->
      <pdf-download></pdf-download>
      <!-- <div class="verticalToolbarSeparator hiddenSmallView"></div>
      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar> -->
    </div>
  </div>
</ng-template>
